export default __webpack_public_path__ + "static/media/cyberpunk.618346f5.jpeg";